// import CameraAltIcon from "@mui/icons-material/CameraAlt";
// import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
// import { blue } from "@mui/material/colors";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectPosition, setEditMode } from "../../toolkits/annotation/slice";
import { updateLidar } from "../../toolkits/lidar/slice";
import { DEFAULT_EDIT_NONE, hasPosition } from "../../utils";

export const SelectLidar = ({ setOpen }) => {
  const dispatch = useDispatch();
  const { lidars } = useSelector((state) => state.lidars);
  const { selectedPosition } = useSelector((state) => state.annotations);

  const notSetupLidars = useMemo(() => {
    return lidars?.filter((lidar) => !hasPosition(lidar)) ?? [];
  }, [lidars]);

  const handleListItemClick = (lidar) => {
    const newLidar = {
      ...lidar,
      camPos: selectedPosition?.camPos,
      lidarPos: selectedPosition?.camPos,
      lookAt: selectedPosition?.lookAt,
    };
    dispatch(updateLidar(newLidar));
    dispatch(setEditMode(DEFAULT_EDIT_NONE));
    dispatch(selectPosition());
    setOpen(false);
  };

  return (
    <List sx={{ pt: 0, minWidth: "300px" }} dense>
      {notSetupLidars.map((item) => (
        <ListItem disableGutters key={item.id}>
          <ListItemButton onClick={() => handleListItemClick(item)}>
            <ListItemText
              primary={item.title}
              primaryTypographyProps={{
                sx: {
                  color: "#ffffffcc",
                },
              }}
              secondary={item.description}
              secondaryTypographyProps={{
                sx: {
                  color: "#ffffffa7",
                },
              }}
            />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};
